<app-header></app-header>

<div class="container">
  <div class="row">
    <div class="col-sm-10 col-sm-offset-1">
      <h1 class="heading">
        <ng-content select=".title"></ng-content>
      </h1>

      <section class="post-date">Posted on:
        <ng-content select=".timestamp"></ng-content>
      </section>

      <section class="page-content">
        <ng-content select=".content"></ng-content>
      </section>
    </div>
  </div>
</div>

<app-footer></app-footer>
